"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostPaymentCreate = void 0;
const Base_1 = require("./Base");
exports.PostPaymentCreate = {
    url: Base_1.URL_BASE + "/create",
    method: "POST",
    secure: false
};
//# sourceMappingURL=PostPaymentCreate.js.map